import React, {useEffect, useState} from 'react';
import './App.css';
import {Col, Row, Typography, Skeleton} from 'antd';
import Link from "antd/es/typography/Link";
import axios from 'axios';

const { Title, Text } = Typography;

function App() {

    const [homeContent, setHomeContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getHomeContent = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/home/?populate=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setHomeContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getHomeContent().then(r => {});
    }, []);

    return(
    <>
        <Row style={{
            maxWidth: '1280px',
            margin: '32px auto',
            textAlign: 'center',
        }}
        >
            <Col span={24} style={{paddingBottom: '32px'}}>
                <Skeleton
                    loading={skeleton}
                    active />
                <Title level={3}>{homeContent['Title']}</Title>
                <Text>{homeContent['Subtitle']}</Text>
            </Col>
        </Row>

        <Row>
            <Col span={12} style={{minHeight: 320}}>
                <div className={'IndustriesContent'}>
                    <Title level={2} style={{marginTop: 0}}>{homeContent['IndustriesTitle']}</Title>
                    <Text className={'TransitionColors'} style={{marginBottom: 32, display: 'block'}}>
                        {homeContent['IndustriesSubTitle']}
                    </Text>

                    <Row>
                            {
                                (homeContent?.IndustriesList ?? []).map((item, value) => {
                                    return <Col key={value} span={12}>
                                                    <Title key={value} level={4}>{item.ListTitle}</Title>
                                                    <small key={value + 1}>{item.ListSubTitle}</small>
                                            </Col>
                                })
                            }
                    </Row>
                </div>
            </Col>
            <Col span={12}
                 style={{minHeight: 420,
                        padding: 24,
                        backgroundImage: `url(${process.env.REACT_APP_STRAPI_URL + homeContent.IndustryBanner?.data?.attributes?.url})`,
                        backgroundSize: 'cover'}}>
                <Title
                    style={{color: "white",
                            textShadow:"1px 2px #333",
                            maxWidth:"500px"}}
                    level={1}>
                    {homeContent['IndustryBannerTitle']}
                </Title>
                <p style={{color: 'white', textShadow:"1px 2px #333", fontSize: 18, maxWidth:"600px"}}>
                    {homeContent['IndustryBannerSubTitle']}
                </p>
            </Col>
        </Row>

        <Row style={{
            maxWidth: '1280px',
            margin: '32px auto',
            textAlign: 'center',
             }}
        >
            <Col span={24}>
                <Title level={3} style={{marginTop: 80}}>{homeContent['PortfolioTitle']}</Title>
                <Text>{homeContent['PortfolioSubTitle']}</Text>
            </Col>
        </Row>

        <Row className={'Portfolio'}
             style={{
            maxWidth: '1280px',
            margin: '32px auto 140px auto',
            textAlign: 'center',
        }}>
            {

                (homeContent?.PortfolioList ?? []).map((item, value) => {
                    return <Col key={value} span={6}>
                        <Title level={4}>{item.Title}</Title>
                        <small>{item.Description}</small>
                        <Link href={item.Link} target={"_blank"}>More</Link>
                    </Col>
                })
            }
        </Row>
        <Row style={{marginTop: 96}}>

            <Col span={12}
                 style={{minHeight: 420,
                     padding: 24,
                     backgroundImage: `url(${process.env.REACT_APP_STRAPI_URL + homeContent.TechnologyEngineeringBanner?.data?.attributes?.url})`,
                     backgroundSize: 'cover'}}></Col>
            <Col span={12} style={{minHeight: 320}}>
                <div className={'TechnologyEngineeringServicesContent'}>
                    <Title level={3} style={{marginTop: 0}}>{homeContent['TechnologyEngineeringTitle']}</Title>
                    <Text className={'TransitionColors'}  style={{marginBottom: 32, display: 'block'}}>{homeContent['TechnologyEngineeringSubTitle']}</Text>

                    <Row>
                        {
                            (homeContent?.TechnologyEngineeringList ?? []).map((item, value) => {
                                return <Col key={value} span={12}>
                                    <Title level={4}>{item.ListTitle}</Title>
                                    <small>{item.ListSubTitle}</small>
                                </Col>
                            })
                        }
                    </Row>
                </div>
            </Col>
        </Row>

        <Row style={{
            maxWidth: '1280px',
            margin: '32px auto',
            textAlign: 'center',
        }}
        >
            <Col span={24}>
                <Title level={3} style={{marginTop: 48}}>{homeContent['ContactsTitle']}</Title>
                <Text>{homeContent['ContactsSubTitle']}</Text>
                <Row style={{padding:'48px 0'}}>
                    {
                        (homeContent?.ContactsDetailsList ?? []).map((item, value) => {
                            return <Col key={value} span={8}>
                                    <Title level={5}>{item.ListTitle}</Title>
                                    <Text style={{paddingLeft: 8}}>{item.ListSubTitle}</Text>
                                   </Col>
                        })
                    }
                </Row>
            </Col>
        </Row>
    </>
    )
}

export default App;